<template>
	<div>
        <!-- 弹窗组件 -->
        <v-dialog v-model="claimORDialog" content-class="v-echarts-dialog" :persistent="claimed" width="500">
            <v-card class="pa-8" rounded="0" elevation="12" color="white01">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card-title class="d-flex px-0">
                            <div class="sidebar-h2 text-primaryGrey mt-3">
                                <span v-if="!claimed">Claim ORs</span>
                                <span v-if="claimed">Claimed!</span>
                            </div>
                            <v-spacer></v-spacer>
                            <v-icon aria-label="close" icon="mdi:mdi-close" class="text-primaryGrey" @click="closeClaimORDialog"></v-icon>
                        </v-card-title>
                        <v-divider class="my-4"></v-divider>
                        <!-- --------------------  领取 ---------------------- -->
                        <div v-if="!claimed">
                            <div class="body-h4 text-primaryGrey mt-8 mb-3">Blockchain</div>
                            <v-text-field v-model="blockchain.blockchain" variant="solo" density="comfortable" hide-details readonly>
                                <template v-slot:prepend-inner>
                                    <Blockchain :blockchain="blockchain.blockchain" size="24"></Blockchain>
                                </template>
                            </v-text-field>
                            <div class="body-h4 text-primaryGrey mt-8 mb-3">Account/Wallet</div>
                            <v-text-field  v-model="user.wallet" variant="solo" density="comfortable" hide-details readonly></v-text-field>
                            <div class="body-h4 text-primaryGrey mt-8 mb-3">
                                <span>Total Unclaimed ORs</span>
                                <v-menu transition="slide-y-transition" open-on-hover :offset="10" location="top">
                                    <template v-slot:activator="{ props }" >
                                        <v-icon icon="mdi:mdi-alert-circle-outline" class="ml-1 text-primaryGrey pointer gradient-text-hover" v-bind="props"></v-icon>
                                    </template>
                                    <v-card max-width="420" class="pa-3 text-primaryGrey body-p" rounded="0">
                                        Minimum claim amount 0.05
                                    </v-card>
                                </v-menu>
                            </div>
                            <div class="body-p text-primaryGrey mb-3"></div>
                            <v-text-field :value="$tools.formatNumber(claimReward.amount)" variant="solo" density="comfortable" hide-details readonly></v-text-field>
                            <div class="text-center mb-5 mt-16">
                                <Button variant="primary" :disabled="amount < 0.05" :loading="loading" rounded="lg" color="black03" width="200" aria-label="Confirm" @click="confirm">Confirm</Button>
                            </div>
                        </div>
                        <!-- --------------------  已领取 ---------------------- -->
                        <div v-if="claimed">
                            <div class="mt-3 body-p text-primaryGrey">
                                Congratulations! Your ORs have been claimed to your wallet.
                            </div>
                            <div class="mt-16 mb-5 gradient-underline-hover">
                                <a :href="$tools.getBlockchainExplorerUrl(claimReward.blockchain) + '/tx/' + claimReward.transactionHash" class="del-underline text-primaryGrey gradient-text-hover body-p pointer" target="_blank">
                                    <i class="iconfont icon-export pr-3 text-primaryGrey"></i>View on {{ blockchain.blockchainExplorer }}
                                </a>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>
        <!-- 钱包组件 -->
        <MetaMask ref="MetaMask" @transactionClose="transactionClose"></MetaMask>
        <Reown ref="Reown" @transactionClose="transactionClose"></Reown>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import { Web3 } from "web3";
import NFTClaimRewardAPI from '@/api/nft-claim-reward.js';
export default {
    data(){
        return {
            // 弹窗
            claimORDialog: false,
            // 加载中
            loading: false,
            // 领取奖励对象参数
            claimReward: {
                type: 'OR',
                blockchain: null,
                transactionHash: null,
                amount: 0,
                token: null
            },
            // 已领取
            claimed: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        amount: {
            type: Number,
            default: 0
        },
        blockchain: {
            type: Object,
            default:  {
                blockchain: null
            }
        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(['user', 'walletType'])
    },
    watch:{
        show: {
            handler(n, o) {
                if(n) {
                    this.claimORDialog = true;
                } else {
                    this.claimORDialog = false;
                }
            },
            immediate: true
        },
        claimORDialog: {
            handler(n, o) {
                if(!n) {
                    this.$emit('watchClaimORDialog', false);
                }
            },
            immediate: true
        },
        amount: {
            handler(n, o) {
                this.claimReward.amount = n;
            },
            immediate: true
        },
    },
    methods: {
        // 确认领取，调起钱包
        async confirm() {
            this.loading = true;
            let web3 = new Web3(new Web3.providers.HttpProvider(this.blockchain.RPCUrl));
            // 编码参数列表
            try {
                // 将函数编码
                let method  = web3.eth.abi.encodeFunctionSignature('releaseOR(address)');
                // 将参数编码
                let param = web3.eth.abi.encodeParameters(['address'], [this.user.wallet]).substring(2);
                // 组装数据
                let data = method + param;
                // 调起钱包发送交易
                if(this.walletType){
                    this.$refs[this.walletType].sendTransaction(this.blockchain.blockchain, this.user.wallet, this.blockchain.unNFTContract, data);
                } else {
                    // 错误通知
                    this.$store.dispatch('snackbarMessageHandler', "Invalid wallet type");
                    // 加载完成
                    this.loading = false;
                }
            } catch (error) {
                console.error(error);
                this.$store.dispatch('snackbarMessageHandler', error);
                // 加载完成
                this.loading = false;
            }
        },
        // 交易关闭：成功/失败
        async transactionClose(success, transactionHash) {
            // 交易成功
            if(success) {
                this.claimed = true;
                // 20231116：NFT 新增异步处理 ORClaimed/FRClaimed 交易记录
                // 保存领取记录
                // this.claimReward.blockchain = this.blockchain.blockchain;
                // this.claimReward.transactionHash = transactionHash;
                // this.claimReward.amount = this.amount;
                // this.claimReward.token = this.blockchain.symbol;
                // this.claimed = true;
                // // 保存
                // let res = await NFTClaimRewardAPI.claimReward(this.claimReward);
                // let data = res.data;
                // if(data.success) {
                    
                // } else {
                //     this.$store.dispatch('snackbarMessageHandler', data.message);
                // }
            }
            // 加载完成
            this.loading = false;
        },
        // 关闭弹窗
        closeClaimORDialog() {
            // 关闭弹窗
            this.$emit('watchClaimORDialog', false);
            // 如果已领取，需要刷新数据
            if(this.claimed) {
                // 取消领取
                this.claimed = false;
                this.$emit('emitGetDashboards', null);
            }
        }
    }
}
</script>
<style scoped>
:deep(.v-echarts-dialog){
    width: auto;
}
</style>